import Switch from './Switch';
export default Switch;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-switch/src/index.js